function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M17.3332 8.99982C17.3332 13.6032 13.6023 17.3332 8.99984 17.3332C4.39734 17.3332 0.666504 13.6032 0.666504 8.99982C0.666504 4.39816 4.39734 0.666489 8.99984 0.666489C13.6023 0.666489 17.3332 4.39816 17.3332 8.99982Z",
  fill: "#EB2D2D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M8.99577 11.4404C9.4066 11.4404 9.73327 11.7679 9.73327 12.1696C9.73327 12.5712 9.4066 12.8987 9.0041 12.8987C8.59994 12.8987 8.27077 12.5712 8.27077 12.1696C8.27077 11.7679 8.5966 11.4404 8.99577 11.4404ZM8.99577 5.11307C9.39744 5.11307 9.72494 5.44057 9.72494 5.84223V9.52557C9.72494 9.92723 9.39744 10.2547 8.99577 10.2547C8.5941 10.2547 8.2666 9.92723 8.2666 9.52557V5.84223C8.2666 5.44057 8.5941 5.11307 8.99577 5.11307Z",
  fill: "#EB2D2D"
});

var SvgInfoCircle = function SvgInfoCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInfoCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Info-Circle.f34eca6b.svg";
export { ForwardRef as ReactComponent };